export const donkeys = [
    "Standard",
    "Miniature",
    "Mammoth",
    "Burro Donkey",
    "Poitou Donkey",
    "Hinny",
    "Grand Noir du Berry"
]